export const generatePath = (lang, slug) => {
    const langPrefix = lang ? lang.substring(0, 2) : ''
    return `/${langPrefix ? `${langPrefix}/` : ''}${slug ? `${slug}/` : ''}`
}

// Mirrors the article URL structure built in gatsby-node.js. Keep the two in
// sync: a category that routes differently there will 404 when linked from here.
export const generateArticleSlug = (category, slug) => {
    switch (category) {
        case 'Events':
        case 'Trips':
            return `events-and-trips/${category.toLowerCase()}/${slug}`
        case 'Archived':
            return `events-and-trips/archived/${slug}`
        case 'Careers':
            return `careers/${slug}`
        case 'News':
        case 'Knowledge':
        case 'Recipes':
            return `blog/${category.toLowerCase()}/${slug}`
        default:
            return `blog/news/${slug}`
    }
}

export const padLeft = number => number.toString().padStart(2, '0')

export const removeLeadingSlashes = string => string.replace(/^\/|\/$/g, '')

export const getOverlayColor = backgroundColor => {
    switch (backgroundColor) {
        case 'Grey': return theme.colors['light']
        case 'White': return theme.colors['white']
    }
}

export const isPreloaderActive = () => {
    return localStorage.getItem('preloaderActive')
}